export const CustomAssets = {
  name: "CustomAssets",
  posisiton: {
    x: 0,
    y: 0,
  },
  components: [
    {
      name: "asset_1",
      type: "Sprite",
      position: { x: 0, y: -44 },
      img: "reel_asset_1",
      anchor: { x: 0.5, y: 0 },
    },
    {
      name: "asset_2",
      type: "Sprite",
      position: { x: 970, y: -44 },
      anchor: { x: 0.5, y: 0 },
      img: "reel_asset_2",
    },
    {
      name: "asset_3",
      type: "Sprite",
      position: { x: 10, y: 673 - 50 },
      anchor: { x: 0.5, y: 0 },
      img: "reel_asset_3",
    },
    {
      name: "asset_4",
      type: "Sprite",
      position: { x: 970, y: 673 - 44 },
      anchor: { x: 0.5, y: 0 },
      img: "reel_asset_4",
    },
    {
      name: "asset_5",
      type: "Sprite",
      position: { x: 971 / 2, y: -46 },
      anchor: { x: 0.5, y: 0 },
      img: "reel_asset_5",
    },
    {
      name: "asset_6",
      type: "Sprite",
      position: { x: 971 / 2, y: 673 - 35 },
      anchor: { x: 0.5, y: 0 },
      img: "reel_asset_6",
    },
  ],
};
